import ApiDocument from "../../gd/api/document"
import Request from "../../gd/data/request"
import Document from "../../../core/model2/doc/document"
import ModalDocument_EditType from "./edit-type/modal-edit-document-type"
import ModalDocument_Duplicate from "./duplicate/duplicate"
import ModalDocument_NewDocumentType from "./document-type/document-type"
import ApiDocumentType from "../../gd/api/document-type"
import {modalMoveDocument} from "../move-to/move"

const debug = false
// const debug = "DocumentModalsManager"

export default class DocumentModalsManager {

    rename(document: Document) {
        gd.modals.oneInput('Name', document.name, 'Rename', async (newName)=>{
            gd.modal.hide()
            await ApiDocument.update(document.id, {name: newName}).promise()
        })
    }

    duplicate(document:Document, callback?:callback) {

        gd.modal.showForm({
            className   : 'modal-copy',
            header      : {
                title: 'Duplicate Document'
            },
            component   : ModalDocument_Duplicate,
            params      : {
                document    : document,
                callback    : callback
            }
        })
    }

    saveAsTemplate(document:Document, callback?:callback) {
        gd.modal.showForm({
            header: {
                title: 'Save As Template',
            },
            component: ModalDocument_NewDocumentType,
            params: {
                onSubmit: async (values: any) => {

                    const response:any = await ApiDocument.saveAsTemplate(
                        document.id,
                        values.name, values.icon, values.description
                    ).promise()

                    gd.modal.hide();

                    callback && callback()
                }
            }
        });
    }

    move(document:Document, callback?:any) {

        return modalMoveDocument(document, {
            callback: callback,
        });

        /*gd.modal.showV4({
            className   : 'modal-move',
            component   : ModalMoveTo,
            params      : {
                noteId          : noteId,
                parentProjectId : parentProjectId,
                companyId       : companyId,
                arrNoteUsers    : arrNoteUsers,
                mode            : ModalMoveTo_Mode.DOCUMENT,
                type            : ModalMoveTo_TargetType.FOLDER,
                onMove          : callback
            }
        });*/
    }

    convertType(document:any, callback?:any) {
        gd.modal.showForm({
            header: {
                title: 'Convert Document'
            },
            component: ModalDocument_EditType,
            params: {
                document: document,
                onSubmit: (values:any)=>{
                    debug && console.log(debug, 'convertType', values)
                    const request:Request = ApiDocument.update(document.id, {
                        noteTypeId: values.documentType,
                    })
                    request.done(()=>{
                        gd.modal.hide()
                        if (callback) callback(values.documentTypes)
                    })
                },
            }
        })
    }

    newDocumentType(callback?:callback) {

        gd.modal.showForm({
            header: {
                title: 'New Document Type',
            },
            component: ModalDocument_NewDocumentType,
            params: {
                onSubmit: async (values: any) => {

                    const response:any = await ApiDocumentType.create(values.name, values.icon, values.description).promise()

                    gd.modal.hide();

                    callback && callback()
                }
            }
        });
    }
}